import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { evidenceBadgeClasses } from '../../data/evidence-presentation';
import {
  costModelSummary,
  organizationCostLabel,
  showSupporterExtra,
  supporterExtraLabel,
} from '../../data/platform-result-presentation';
import type {
  PlatformId,
  PlatformOptionChange,
  PlatformOverviewViewModel,
} from '../../models/fundraising-comparison.models';
import { PlatformOptionsComponent } from '../platform-options/platform-options.component';

@Component({
  standalone: true,
  selector: 'app-platform-quick-view',
  imports: [CommonModule, PlatformOptionsComponent],
  templateUrl: './platform-quick-view.component.html',
  styleUrls: ['./platform-quick-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformQuickViewComponent {
  @Input() row?: PlatformOverviewViewModel;
  @Output() optionChange = new EventEmitter<PlatformOptionChange>();
  @Output() quickViewClosed = new EventEmitter<PlatformId>();
  @Output() fullPageClicked = new EventEmitter<PlatformId>();

  evidenceBadgeClasses = evidenceBadgeClasses;

  get result() {
    return this.row?.result;
  }

  get currentCostModel(): string {
    return this.result ? costModelSummary(this.result) : '';
  }

  get showSupporterExtra(): boolean {
    return this.result ? showSupporterExtra(this.result) : false;
  }

  get organizationCostLabel(): string {
    return this.result ? organizationCostLabel(this.result) : '';
  }

  get supporterExtraLabel(): string {
    return this.result ? supporterExtraLabel(this.result) : '';
  }

  get supporterExtraValue(): string {
    if (!this.result) return '';
    return this.result.donorPaidExtraEstimated
      ? this.formatMoney(this.result.donorPaidExtraCents)
      : 'Optional — not estimated';
  }

  onHidden(): void {
    if (this.result) this.quickViewClosed.emit(this.result.platformId);
  }

  formatMoney(amountCents: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: amountCents % 100 === 0 ? 0 : 2,
    }).format(amountCents / 100);
  }
}
